<template>
  <section class="contact-container">
    <div class="wrap">
      <h3 class="contact-title">{{ CONTACT_TITLE }}</h3>
    </div>
    <div class="contact-bg">
      <div class="wrap">
        <div class="contact-box">
          <div class="left">
            <p class="hint">{{ HINT_TEXT }}</p>
            <div class="sep"></div>
            <div class="row">
              <div class="icon-stack">
                <img :src="circulo" class="icon-bg" alt="" />
                <img :src="telefonoIcon" class="icon-main" alt="Teléfono" />
              </div>
              <div class="text-group">
                <div class="label">Teléfono</div>
                <div class="value">55 7600 6440</div>
              </div>
            </div>
            <div class="row">
              <div class="icon-stack">
                <img :src="circulo2" class="icon-bg" alt="" />
                <img :src="mailIcon" class="icon-main" alt="Correo" />
              </div>
              <div class="text-group">
                <div class="label">Correo de atención</div>
                <a class="value link" href="mailto:atencionaclientesbienestarazteca@bancoazteca.com">
                  atencionaclientesbienestarazteca@bancoazteca.com
                </a>
              </div>
            </div>
          </div>
          <div class="right">
            <img class="logo" src="@/assets/images/BancoAzteca.png" alt="Banco Azteca" />
          </div>
        </div>
      </div>
    </div>
    <div class="wrap">
      <div class="links">
        <a
          :href="HREF_AVISO"
          target="_blank" rel="noreferrer noopener" class="l">{{ LINK_AVISO }}</a>
        <a
          :href="HREF_CONTRATO"
          target="_blank" rel="noreferrer noopener" class="l">{{ LINK_CONTRATO }}</a>
        <a
          href="https://d1mq21xo4bjiqa.cloudfront.net/documentos/Terminos_y_condiciones.pdf"
          target="_blank" rel="noreferrer noopener" class="l">{{ LINK_TERMINOS }}</a>
      </div>
      <div class="bottom">{{ BOTTOM_TEXT }}</div>
    </div>
  </section>
</template>

<script setup>
import circulo from '@/assets/icons/circulo.png'
import circulo2 from '@/assets/icons/circulo2.png'
import mailIcon from '@/assets/icons/mailIcon.png'
import telefonoIcon from '@/assets/icons/telefonoIcon.png'

const CONTACT_TITLE = 'Contáctanos'
const HINT_TEXT = '¿Necesitas ayuda? Acércate con nosotros y obtén la asesoría adecuada para ti.'
const HREF_AVISO = 'https://d1mq21xo4bjiqa.cloudfront.net/documentos/' +
  'API_BAZ_Website_originacion_App_V2_Enero_2026.pdf'
const LINK_AVISO = 'Aviso de Privacidad'
const HREF_CONTRATO = 'https://d1mq21xo4bjiqa.cloudfront.net/documentos/' +
  'Contrato_Unico_Cuentas_Avanza_y_Bienestar_Jovenes_VF.pdf'
const LINK_CONTRATO = 'Contrato'
const LINK_TERMINOS = 'Términos y condiciones'
const BOTTOM_TEXT =
  'Si requieres información sobre tu cuenta, tienes alguna aclaración o ' +
  'necesitas asesoría para cancelación, comunícate a la línea ' +
  'Bienestar Azteca: 55 7600 6440 las 24 hrs los 365 días del año.'
</script>

<style scoped>
.contact-container {
  background: #ffffff;
  padding: 40px 0 60px;
  width: 100%;
}

.wrap {
  max-width: 1640px;
  margin: 0 auto;
  padding: 0 20px;
}

.contact-title {
  font-weight: 800;
  font-size: 28px;
  text-align: left;
  color: #2b2b2b;
  margin-bottom: 0;
}

.contact-bg {
  background: #f1f3f6;
  width: 100%;
  padding: 40px 0;
  margin: 20px 0 40px;
}

.contact-box {
  display: grid;
  grid-template-columns: 1fr 200px;
  align-items: flex-start;
  gap: 100px;
}

.left {
  text-align: left;
}

.hint {
  margin: 0 0 12px;
  color: #6b6b6b;
  font-size: 13px;
  line-height: 1.5;
}

.sep {
  height: 1px;
  background: #d1d1d1;
  margin: 12px 0 20px;
  max-width: 100%;
}

.row {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  margin: 18px 0;
}

.icon-stack {
  position: relative;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.icon-bg {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.icon-main {
  position: absolute;
  width: 22px;
  height: auto;
}

.text-group {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 2px;
}

.label {
  font-weight: 900;
  color: #2b2b2b;
  font-size: 13px;
  margin-bottom: 2px;
}

.value {
  color: #6b6b6b;
  font-size: 14px;
  line-height: 1.4;
}

.link {
  text-decoration: underline;
}

.link:hover {
  color: #17a54d;
}

.right {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  padding-top: 5px;
}

.logo {
  width: 160px;
  height: auto;
  margin-top: 0;
}

.links {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
}

.l {
  color: #6b6b6b;
  font-size: 13px;
  text-decoration: underline;
  width: fit-content;
  transition: color 0.3s ease;
  cursor: pointer;
}

.l:hover {
  color: #17a54d;
}

.bottom {
  margin-top: 50px;
  text-align: center;
  color: #888;
  font-size: 13px;
  line-height: 1.6;
}

/* ========================================
   RESPONSIVE
======================================== */
@media (max-width: 900px) {
  .wrap {
    padding: 0 20px;
  }

  .contact-title {
    font-size: 24px;
  }

  .contact-box {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    gap: 30px;
  }

  .left {
    width: 100%;
    text-align: left;
  }

  .sep {
    margin: 12px 0 20px 0;
    max-width: 100%;
  }

  .row {
    justify-content: flex-start;
    gap: 12px;
    margin: 15px 0;
  }

  .icon-stack {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
  }

  .icon-main {
    width: 20px;
  }

  .value {
    font-size: 13px;
    word-break: break-all;
  }

  .right {
    width: 100%;
    justify-content: center;
    margin-top: 20px;
    padding-top: 0;
  }

  .logo {
    width: 140px;
  }
}

@media (max-width: 480px) {
  .contact-title {
    font-size: 20px;
  }

  .hint {
    font-size: 12px;
  }

  .label {
    font-size: 12px;
  }

  .value {
    font-size: 12px;
  }

  .l {
    font-size: 12px;
  }

  .bottom {
    font-size: 12px;
    margin-top: 30px;
  }
}
</style>